__turbopack_context__.v({
  "card": "enriched-skills-module-scss-module__REJuLq__card",
  "card-image": "enriched-skills-module-scss-module__REJuLq__card-image",
  "card-image-wrapper": "enriched-skills-module-scss-module__REJuLq__card-image-wrapper",
  "card-label": "enriched-skills-module-scss-module__REJuLq__card-label",
  "card-label-arrow": "enriched-skills-module-scss-module__REJuLq__card-label-arrow",
  "card-label-title": "enriched-skills-module-scss-module__REJuLq__card-label-title",
  "cards-area": "enriched-skills-module-scss-module__REJuLq__cards-area",
  "controls-skeleton": "enriched-skills-module-scss-module__REJuLq__controls-skeleton",
  "controls-skeleton-bar": "enriched-skills-module-scss-module__REJuLq__controls-skeleton-bar",
  "enriched-skills": "enriched-skills-module-scss-module__REJuLq__enriched-skills",
  "enriched-skills--mweb-optimized-search": "enriched-skills-module-scss-module__REJuLq__enriched-skills--mweb-optimized-search",
  "heading-area": "enriched-skills-module-scss-module__REJuLq__heading-area",
  "headline": "enriched-skills-module-scss-module__REJuLq__headline",
  "inner-grid": "enriched-skills-module-scss-module__REJuLq__inner-grid",
  "mobile-card-grid": "enriched-skills-module-scss-module__REJuLq__mobile-card-grid",
  "slide-layout": "enriched-skills-module-scss-module__REJuLq__slide-layout",
  "supporting-text": "enriched-skills-module-scss-module__REJuLq__supporting-text",
});
